import { useModal } from "context/ModalContext/Modal.context";
import { useEffect, useRef, useState } from "react";
import { setStorageItem } from "utils/storage";

import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import SwiperCore, { Swiper as swiper } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Step, Tutorial } from "types/tutorial";
import { NavigationOptions } from "swiper/types/modules/navigation";

import "./style.scss";
import { useNavigate } from "react-router";
import { getInformativos } from "services/informativos.service";

interface Options {
  onlyClose?: boolean;
}

const ModalInformativo = ({ onlyClose }: Options) => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const { closeModal } = useModal();
  const [informativo, setInformativo] = useState<Tutorial>();
  const swiperRef = useRef<SwiperCore | null>(null);
  const [isLast, setIsLast] = useState(false);

  const refPrev = useRef<HTMLButtonElement>(null);
  const refNext = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const fetchInformativos = async () => {
      const response = await getInformativos("67a3aa753de8c3182e916c80");
      setInformativo(response);
    };
    fetchInformativos();
  }, []);

  const onClose = () => {
    setStorageItem("check_tutorial", "true");
    closeModal();
    if (!onlyClose) {
      navigate("/realizations");
    }
  };

  if (!informativo?.steps || informativo.steps.length === 0) {
    return null; // Or show a fallback message
  }

  return (
    <div className="p-2 bg-white rounded-lg md:p-8">
      <Swiper
        modules={[Navigation, Pagination, A11y]}
        spaceBetween={0}
        slidesPerView={1}
        pagination={{ clickable: true }}
        scrollbar={{ draggable: true }}
        onSwiper={(swiper: SwiperCore) => {
          swiperRef.current = swiper;
          if (swiper.params.navigation) {
            (swiper.params.navigation as NavigationOptions).prevEl =
              refPrev.current;
            (swiper.params.navigation as NavigationOptions).nextEl =
              refNext.current;
            swiper.navigation.update();
          }
        }}
        onSlideChange={(swiper: SwiperCore) => {
          console.log({
            st: informativo.steps.length,
            c: swiper.activeIndex,
          });
          setCurrentIndex(swiper.activeIndex);
          if (informativo.steps.length - 1 === swiper.activeIndex) {
            setIsLast(true);
          } else {
            setIsLast(false);
          }
          console.log(swiper);
        }}
      >
        {informativo?.steps.map((item: Step, index: number) => (
          <SwiperSlide key={index}>
            <div
              className="inner-content"
              dangerouslySetInnerHTML={{ __html: item.text }}
            ></div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="flex items-center justify-center gap-8 actions">
        {currentIndex === 0 ? (
          <button
            ref={refPrev}
            onClick={(e) => swiperRef.current?.slideNext()}
            className="btn bg-yellow-bb text-blue-bb-1 rounded-[4px] py-3 px-4 font-bb font-bold uppercase"
          >
            Próximo
          </button>
        ) : (
          <>
            <button
              ref={refPrev}
              onClick={(e) => swiperRef.current?.slidePrev()}
              className="bg-gray-bb-6 text-blue-bb-1 rounded-[4px] py-3 px-4 font-bb font-bold uppercase"
            >
              Voltar
            </button>
            <button
              ref={refNext}
              onClick={(e) => {
                if (isLast) {
                  onClose();
                } else {
                  swiperRef.current?.slideNext();
                }
              }}
              className="btn bg-yellow-bb text-blue-bb-1 rounded-[4px] py-3 px-4 font-bb font-bold uppercase"
            >
              {isLast ? "Fechar" : "Continuar"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ModalInformativo;
